import { isEmpty } from './isEmpty';
import { getActiveShipmentMode } from './getActiveShipmentMode';

/**
 * @memberof module:util
 * @function
 * @name getPostalUpdatedFclLclAirJson
 * @description It adds "zip code" entered by user, and zip code post request response obj
 * to the corresponding pickup/ers/delivery option .
 *
 * @param {Object} correctFullJson - Full FCL/LCL/AIR json
 * @param {Redux.Store} getState - Whole Redux Store State
 * @param {Object} optionItemObj - It contains zip code post request response obj
 * @returns {Object} updated full FCL/LCL/AIR json
 *
 */
export const getPostalUpdatedFclLclAirJson = (
  correctFullJson,
  getState,
  optionItemObj
) => {
  if (!optionItemObj.option || isEmpty(optionItemObj.option)) {
    return null;
  }
  if (
    optionItemObj.optionMode &&
    optionItemObj.optionMode !== optionItemObj.mode
  ) {
    return correctFullJson;
  }

  // console.log('getPostalUpdatedFclLclAirJson optionItemObj', optionItemObj);

  const { fclActive, lclActive, airActve } = getActiveShipmentMode(getState);

  correctFullJson = { ...(correctFullJson || {}) };

  let modeSection;
  if (optionItemObj.mode === PICKUP) {
    modeSection = PICKUP_SECTION;
  } else if (optionItemObj.mode === ERS) {
    modeSection = ERS_SECTION;
  } else if (optionItemObj.mode === DELIVERY) {
    modeSection = DELIVERY_SECTION;
  }

  let apiTypeKey; //fcl or lcl or air

  if (fclActive) {
    apiTypeKey = 'fcl';
  } else if (lclActive) {
    apiTypeKey = 'lcl';
  } else if (airActve) {
    apiTypeKey = 'air';
  }

  // check if fcl/lcl/air key present or not in rate json
  if (
    !correctFullJson ||
    isEmpty(correctFullJson) ||
    !correctFullJson.rates ||
    !Array.isArray(correctFullJson.rates[apiTypeKey])
  ) {
    return null;
  }

  correctFullJson.rates[apiTypeKey].map((itemJson) => {
    let correctSingleJson; //one fcl/lcl/air item json which also contains pickup section, delvery section, delievry section

    // get all the original array in mode section i.e. pickup_section arr for example
    let originalModeSectionArr;

    if (itemJson.id !== optionItemObj.itemJsonId) {
      return null;
    }

    correctSingleJson = {
      ...(itemJson || {}),
    };

    originalModeSectionArr = [...(itemJson[modeSection] || [])];

    // console.log('before optionItemObj', optionItemObj);

    // console.log('before originalModeSectionArr', modeSectionArr);

    // update arrays in mode section array
    if (Array.isArray(originalModeSectionArr)) {
      // add new zip code response
      originalModeSectionArr = originalModeSectionArr.map((singleOption) => {
        const shouldUpdateByZip =
          optionItemObj?.option?.fetch_zip_code && singleOption?.fetch_zip_code;
        const shouldUpdateById =
          !optionItemObj?.option?.fetch_zip_code &&
          singleOption &&
          singleOption.id === optionItemObj.optionId;
        if (shouldUpdateByZip || shouldUpdateById) {
          return {
            ...optionItemObj.option, //add new post request response obj
            id: singleOption.id,
            zipCode: optionItemObj.zipCode, //add zip code
          };
        }
        return singleOption;
      });

      // console.log(
      //   'before originalModeSectionArr, ************',
      //   originalModeSectionArr
      // );

      //only for form zip code submit for new/existing factory
      if (optionItemObj.formZipCodeSubmit) {
        //  console.log("before originalModeSectionArr",originalModeSectionArr);

        // remove zip code option with fetch_zip_code=true
        originalModeSectionArr = originalModeSectionArr.filter(
          (singleOption) => {
            if (singleOption && !singleOption.fetch_zip_code) {
              //  only return non zip code options
              return singleOption;
            }
          }
        );
        //  console.log("after originalModeSectionArr",originalModeSectionArr);

        // get all ids of options in originalModeSectionArr
        let tempIdsArr = [];
        // console.log('originalModeSectionArr', originalModeSectionArr);
        originalModeSectionArr.map((singleOption) => {
          singleOption && tempIdsArr.push(singleOption.id);
        });
        // console.log({ tempIdsArr });
        // only push if it's id is not present in tempIdsArr
        if (!tempIdsArr.includes(optionItemObj.optionId)) {
          originalModeSectionArr.push({
            ...optionItemObj.option,
            id: optionItemObj.optionId,
            zipCode: optionItemObj.zipCode,
          });
          // console.log(
          //   'after originalModeSectionArr, ************',
          //   originalModeSectionArr
          // );
        }
      }
    }

    // console.log('after originalModeSectionArr', originalModeSectionArr);
    // update correctFullJson
    correctSingleJson[modeSection] = originalModeSectionArr;

    // console.log('final correctSingleJson', correctSingleJson);

    // get all item jsons from  original correctFullJson
    let allItemsJsonArr = correctFullJson.rates[apiTypeKey].map((itemJson) => {
      // if (itemJson.id === correctSingleJson.id) {
      if (itemJson.uuid ? (itemJson.uuid === correctSingleJson.uuid && itemJson.id === correctSingleJson.id) : (itemJson.id === correctSingleJson.id)) {
        return correctSingleJson; //updated item json
      }

      return itemJson;
    });

    // update original correctFullJson
    correctFullJson.rates[apiTypeKey] = allItemsJsonArr;
  });

  // console.log('final correctFullJson', correctFullJson);

  return correctFullJson;
};

// mode
const PICKUP = 'pickup';
const DELIVERY = 'delivery';
const ERS = 'ers';
// for json, mode section
const PICKUP_SECTION = 'pickup_section';
const DELIVERY_SECTION = 'delivery_section';
const ERS_SECTION = 'ers_section';
